import React from "react";
import { useStore } from "../../store";

interface SlewIndicatorProps {
  className?: string;
  angle?: number;
}

export const SlewIndicator: React.FC<SlewIndicatorProps> = ({
  className = "",
  angle = 0,
}) => {
  const { craneParameters } = useStore();

  // Use store values if not provided as props
  const maxAngle = craneParameters.slewMaxAngle;
  const minAngle = craneParameters.slewMinAngle;

  const isMoving = craneParameters.slewSpeed !== 0;

  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_923_25509)">
        <path
          d="M31.5386 40.4805H48.734C54.1648 40.4805 54.1648 42.7096 54.1648 42.7096C54.1648 42.7096 54.1648 44.9387 48.734 44.9387H41.6179H31.5386C31.3134 44.9387 31.1309 44.7561 31.1309 44.5309V44.3814V41.0377V40.8882C31.1309 40.663 31.3134 40.4805 31.5386 40.4805Z"
          fill="white"
          fillOpacity="0.2"
          stroke="white"
          strokeWidth="0.58377"
        />
        <circle
          cx="43"
          cy="43"
          r="40.9426"
          stroke="white"
          strokeWidth="1.03922"
        />
        <circle
          cx="42.9543"
          cy="43"
          r="29.7371"
          stroke="white"
          strokeWidth="0.754797"
        />
        <circle cx="42.9568" cy="43.0008" r="2.12775" fill="white" />
        {/* <path
          d="M42.956 42.9106L56.0718 4.10938"
          stroke="white"
          strokeWidth="1.81863"
        /> */}
        <path
          d="M84.1277 42.5586H42.5589"
          stroke="white"
          strokeWidth="0.519609"
          strokeDasharray="2.08 2.08"
        />
      </g>
      <g mask="url(#circle)">
        <path
          d={`M43 43 L${43 + Math.sin(((0 + 90) * Math.PI) / 180) * 43} ${
            43 - Math.cos(((0 + 90) * Math.PI) / 180) * 43
          }
          L86 43  L${43 + Math.sin(((angle + 90) * Math.PI) / 180) * 43} ${
            43 - Math.cos(((angle + 90) * Math.PI) / 180) * 43
          }`}
          fill={isMoving ? "#00E676" : "#D7DADC"}
        />
        <path
          d={`M43 43 L${
            43 + Math.sin(((minAngle + 90) * Math.PI) / 180) * 43
          } ${43 - Math.cos(((minAngle + 90) * Math.PI) / 180) * 43}`}
          stroke="#CD151D"
          strokeWidth="1.81863"
        />
        <path
          d={`M43 43 L${
            43 + Math.sin(((maxAngle + 90) * Math.PI) / 180) * 43
          } ${43 - Math.cos(((maxAngle + 90) * Math.PI) / 180) * 43}`}
          stroke="#CD151D"
          strokeWidth="1.81863"
        />
      </g>

      <path
        d={`M43 43 L${43 + Math.sin(((angle + 90) * Math.PI) / 180) * 43} ${
          43 - Math.cos(((angle + 90) * Math.PI) / 180) * 43
        }`}
        stroke="white"
        strokeWidth="1.81863"
      />

      <defs>
        <clipPath id="clip0_923_25509">
          <rect width="86" height="86" fill="white" />
        </clipPath>

        <mask id="circle">
          <rect width="86" height="86" fill="black" />
          <circle cx="43" cy="43" r="40.9426" fill="white" />
          <circle cx="43" cy="43" r="29.7371" fill="black" />
        </mask>
      </defs>
    </svg>
  );
};
